<template>
    <div>
        <page-header :buttons="pageActions.buttons" :additional="pageActions.additional" @method="methodHandler">
            <template slot="title">Suppliers</template>
        </page-header>
        <pro-table
            :resource="resource"
            prefix="/configuration/"
            :fields="fields"
            :filters="filters"
            :filters-loading="filtersLoading"
            :limit="500"
            ref="datatable"
            class="px-6 pt-2"
            @action="actionHandler"
            sort="name"
            direction="ASC"
            delete-label="name"
            :permissions="true"
            :actions="actions"
        ></pro-table>
    </div>
</template>

<script>
    import DataTableSetup from '../../mixins/DataTableSetup';

    export default {
        name: "Suppliers",
        mixins: [ DataTableSetup ],
        data: function() {
            return {
                resource: 'suppliers',
                numberOfFilters: 1,
                pageActions: {},
                fields: [
                    {
                        name: 'ID',
                        column: 'friendly_id'
                    },
                    {
                        name: 'Name',
                        column: 'name',
                        columnClass: 'w-1/5'
                    },
                    {
                        name: 'Type',
                        column: 'types',
                        array: true,
                        field: 'name',
                        columnClass: 'w-1/6'
                    },
                    {
                        name: 'Account Type',
                        column: 'accountType.name',
                    },
                    {
                        name: 'Phone',
                        column: 'phone'
                    },
                    {
                        name: 'Mobile',
                        column: 'mobile'
                    },
                    {
                        name: 'Email',
                        column: 'email',
                    }
                ],
                actions: {
                    display: true,
                    class: [],
                    options: [
                        { label: 'View', link: 'view', icon: 'eye',  type: 'router-link', tooltip: 'View', permissions: 'suppliers.show' },
                        { label: 'Edit', link: 'edit', icon: 'edit', type: 'router-link', tooltip: 'Edit', permissions: 'suppliers.edit' },
                        { label: 'Delete', method: 'delete', icon: 'trash-alt', type: 'method', tooltip: 'Delete', permissions: 'suppliers.destroy' },
                    ]
                }
            }
        },
        methods: {
            methodHandler: function(method){
                this[method]();
            },
        },
        mounted() {
            //Search Filter
            const searchFilter = {
                label: 'Search',
                name: 'search',
                type: 'text',
                width: 'w-1/4',
                value: this.searchValue,
                placeholder: 'Search...'
            };

            this.filters.push(searchFilter);

            this.pageActions = {
                buttons: [
                    {
                        label: 'New Supplier',
                        icon: 'plus',
                        type: 'router-link',
                        link: '/configuration/suppliers/create',
                        iconClass: 'text-green-600',
                        display: this.$store.getters.permissions.indexOf('suppliers.create') !== -1
                    }
                ],
                additional: []
            }
        }
    }
</script>

<style scoped>

</style>
